import mutations from './appointmentMandocError.mutations'
import actions from './appointmentMandocError.actions'
import getters from './appointmentMandocError.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
